<template>
    <div class="sidebar-item">
        <router-link 
            :to="sidebarItem.route"
            class="sidebar-item__link"
        >
            <img-container
                :lazySrc="sidebarItem.icon"
                :lazySrcset="sidebarItem.icon"
                :width="!isOpen || isSmallWindow ? 28 : 18"
                class="sidebar-item__link-icon"
                v-tooltip="{ content: !isOpen || isSmallWindow ? sidebarItem.name : '', placement: tooltipPosition }"
            />
            <span
                v-if="isOpen && !isSmallWindow"
                class="sidebar-item__link-text"
            >
                {{sidebarItem.name}}
            </span>
        </router-link>
    </div>
</template>

<script>
import ImgContainer from '../Base/ImgContainer';
export default {
    name: 'SidebarItem',
    components: {
        ImgContainer
    },
    /**
     * Входные данные
     * @property {object} sidebarItem - элемент сайдбара
     * @property {boolean} isOpen - режим сайдбара
     * @property {boolean} isSmallWindow - условие для свернутого сайдбара
     * @property {string} tooltipPosition - позиция подсказки
     */
    props: {
        sidebarItem: {
            type: Object,
            default: () => ({})
        },
        isOpen: {
            type: Boolean,
            default: true,
        },
        isSmallWindow: { 
            type: Boolean, 
            default: false 
        },
        tooltipPosition: { 
            type: String, 
            default: "right" 
        }
    }
}
</script>

<style lang="scss" scoped>
    .sidebar-item__link {
        display: flex;
        align-items: center;
        text-decoration: none;
        color: #b0b1b4;
        padding: 10px;
        border-radius: 4px;
        transition: .3s;
        cursor: pointer;
        margin-top: 5px;
    }
    .sidebar-item__link:hover,.router-link-active {
        background: #f1f3f5;
        color: #000;
    }
    .sidebar-item__link-icon {
        width: 18px;
    }
    .sidebar-item__link-text {
        font-size: 13px;
        margin-top: 2px;
        margin-left: 20px;
    }
</style>